import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import unionBy from 'lodash/unionBy';
import { sortByFullName } from '~/ui/pages/Reports/helpers/sortByName';
import { IClientActions, IClientStore, IThunkGetClientsMapList } from '../types';
import { IClientListResponse, IClient } from '~/services/api/client/types';

const onGetClientsMapList: IThunkGetClientsMapList = thunk(
  async ({ setClients }: Actions<IClientActions>, payload, { getState }) => {
    const state = getState() as IClientStore;
    const { clinicId, teamId, teamIds, params } = payload;

    const getMergedItems = (data: IClientListResponse) =>
      (unionBy([...data.items, ...state.list], 'id') || []).sort(sortByFullName);

    if (teamId) {
      const data = await api.client.getTeamClients(clinicId, teamId, params).then(r => r.data);

      setClients({
        items: params.pageNumber === 1 ? data.items : (getMergedItems(data) as IClient[]),
        pagination: { ...params, total: data.total },
      });
      return;
    }

    const data = await api.client.getClients(clinicId, teamIds, params).then(r => r.data);

    setClients({
      items: params.pageNumber === 1 ? data.items : getMergedItems(data),
      pagination: { ...params, total: data.total },
    });
  },
);

export default onGetClientsMapList;
